import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class ScrollService {
    @Output() onScroll: EventEmitter<any> = new EventEmitter();
    @Output() openRightSideNav: EventEmitter<any> = new EventEmitter();
    @Output() progressBar: EventEmitter<any> = new EventEmitter();
    public type = 'search';

    broadcastScrollEvent(e: any) {
        this.onScroll.emit(e);
    }

    openSideNav(type: string) {
        this.type = type;
        this.openRightSideNav.emit({ type: type });
    }

    closeSideNav() {
        this.openRightSideNav.emit({ type: 'close' });
    }

    toggleProgressBar(status: boolean) {
        this.progressBar.emit({ data: status });
    }
    enableScrollIfDisabled(){
        if (document.getElementById('Ui123456') != null) {
            document.getElementById('Ui123456').className = 'app-content';
        }
        if (document.getElementById('Ui12345') != null) {
            document.getElementById('Ui12345').className = 'app-content';
        }
    }
}


export class ScrollParams {
    public to: number = 0;
    public from: number = 0;
    public page: number = 1;
    public size: number = 20;
    public recordsFinished: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/api/services/scroll.service.ts